module.exports = __webpack_public_path__ + "static/media/trainerTwo.db6c1644.jpg";